import { AngularFirestore } from '@angular/fire/firestore';
import { AuthUserService } from '../auth/auth-user.service';
import { DocumentReference } from '@firebase/firestore-types';
import { Injectable } from '@angular/core';
import { NfmbDataService } from '../nfmb-data.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { Organization, Organizations } from './organization.model';
import { Profiles } from '../profiles/profile.model';
import { switchMap, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService extends NfmbDataService {

  private domainFilter$: BehaviorSubject<string>;

  constructor(
    afs: AngularFirestore,
    authUserService: AuthUserService
  ) {
    super(afs, authUserService, 'organizations');
    this.domainFilter$ = new BehaviorSubject(null);

    this.permissions = {
      edit: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN
      ],
      delete: [
        Profiles.Role.ROOT
      ],
      read: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN
      ],
      switch: [
        Profiles.Role.ROOT
      ]
    };
  }

  get data$(): Observable<Organization[]> {
    return this.domainFilter$.pipe(
      switchMap(domain => {
        return this.afs.collection<Organization>(this.collectionPath,
          ref => {
            let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
            if (domain) { query = query.where(Organizations.IndexField.DOMAIN, '==', domain); }
            query = query.orderBy(Organizations.IndexField.CREATED_AT, 'desc');
            return query;
          }
        ).valueChanges({ idField: 'id' });
      }),
      shareReplay(1)
    );
  }

  public filterByDomain(domain: string): void {
    return this.domainFilter$.next(domain);
  }

  public push(item: any): Promise<DocumentReference> {
    const timestamp = this.timestamp;

    return this.afs.collection<Organization>(this.collectionPath).add({
      ...item,
      createdAt: timestamp,
      modifiedAt: timestamp,
    });
  }
}
